<template>
  <el-dialog
    title="选择岗位离职"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="500px"
  >
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <el-form-item label="员工姓名">
        <span>{{ employeeName }}</span>
      </el-form-item>
      <el-form-item label="选择岗位" prop="employeeId">
        <el-select v-model="form.employeeId" placeholder="请选择岗位" clearable multiple style="width: 100%;">
          <el-option v-for="item in filteredEmployeeList" :key="item.id" :label="item.department.name + ' - ' + item.position.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible" size="small">取消</el-button>
      <el-button type="primary" @click="onSubmit" size="small" :loading="loading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import AfuncApi from '@/api/afunc.js';

export default {
  props: ["open_add", "ma_yg_id", "employeeName", "employeeList"],
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        employeeId: []
      },
      rules: {
        employeeId: [{ required: true, message: '请选择岗位', trigger: 'change' }]
      }
    };
  },
  computed: {
    filteredEmployeeList() {
      if (this.employeeList && Array.isArray(this.employeeList)) {
        return this.employeeList.filter(item => item.resign_aduit != 2);
      }
      return [];
    }
  },
  created() {
    this.dialogVisible = this.open_add;
  },
  methods: {
    dialogFormVisible() {
      this.$emit("close", {});
    },
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          AfuncApi.call({
            model: 'ma_yg',
            action: 'resign',
            ma_yg_id: self.ma_yg_id,
            ids: self.form.employeeId
          })
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/ma_yg/index/part/ResignPosition.vue